import type { FieldInputProps } from 'formik';

import { FormControl, FormLabel, Select } from '@frontend/components';
import { isObject } from '@frontend/utils';

import { GRAIN_DIRECTION_OPTIONS } from './GrainDirectionFieldLabels';
import type {
  NestingSelectOption,
  NestingDefaultsData,
  FormInputProps,
} from './types';

type GrainDirectionFieldProps = {
  field: FieldInputProps<string | null>;
  form: FormInputProps<NestingDefaultsData>;
  isSubmitting: boolean;
};

export const GrainDirectionField = ({
  field,
  form,
  isSubmitting,
}: GrainDirectionFieldProps) => {
  return (
    <FormControl isReadOnly={isSubmitting}>
      <FormLabel fontWeight={600}>Grain Direction</FormLabel>
      <Select
        value={
          isObject(field.value)
            ? field.value
            : GRAIN_DIRECTION_OPTIONS.find(
                (opt) => field.value === opt.value,
              ) ?? ''
        }
        aria-label="Grain Direction Dropdown"
        onChange={(opt: NestingSelectOption) => {
          form.setFieldValue('grainDirection', opt.value, false);
        }}
        isClearable={false}
        isDisabled={isSubmitting}
        options={GRAIN_DIRECTION_OPTIONS}
      />
    </FormControl>
  );
};
